import React from 'react';

import {
  MISSION_PATH,
  BREEDER_QUALITY_PATH,
  SHELTER_QUALITY_PATH
} from 'dpl/shared/constants/urls';

export default function PrismicBuyerMissionContent() {
  return (
    <div className="PrismicBuyerMissionContent">
      <p>
        Good Dog is{' '}
        <a className="link--primary" href={MISSION_PATH}>
          on a mission
        </a>
        &nbsp;to educate the public and make it simple for people to get dogs
        from good sources and for&nbsp;
        <a className="link--primary" href={BREEDER_QUALITY_PATH}>
          reputable breeders,
        </a>
        &nbsp;
        <a className="link--primary" href={SHELTER_QUALITY_PATH}>
          shelters and rescues
        </a>
        &nbsp;to put their dogs in good homes.
      </p>
    </div>
  );
}
